import styled from 'styled-components';
import Color from 'constants/color';
import { Layout } from 'antd';

interface StyledLayoutProps {
  $isMobileView: boolean;
}

export const ContainerLogin = styled.div`
  min-height: 100vh;
  min-width: 100%;
  background-repeat: no-repeat;
  object-fit: cover;
  background-position: center;
  background-size: cover;
  overflow: hidden;
  height: 100%;
  .content-header {
    padding: 24px 12px 0px 12px !important;
  }
`;

export const ContainerBackoffice = styled.div`
  min-height: 100vh;
  min-width: 99.01vw;
  background: ${Color.whteGray2};
  background-repeat: no-repeat;
  object-fit: cover;
  background-position: center;
  background-size: cover;
  overflow: hidden;
  height: 100%;
  .content-header {
    padding: 24px 12px 0px 12px !important;
  }
`;

export const LayoutContenBody = styled(Layout) <StyledLayoutProps>`
  padding: ${(props) => props.$isMobileView && '0 15px'};
  
`;
